const config: {
  base_url: {
    base: string
    dev: string
    pro: string
    test: string
  }
  result_code: number | string
  default_headers: AxiosHeaders
  request_timeout: number
} = {
  /**
   * api请求基础路径
   */
  
  base_url: {
    // 开发环境接口前缀
    base: 'http://zscrmdev.yejibao.vip/index.php/',
    // base: 'http://192.168.0.243:9511/index.php/',

    // 打包开发环境接口前缀
    dev: 'http://zscrmdev.yejibao.vip/index.php/',
    // dev: 'http://192.168.0.243:9999/index.php/',

    // 打包测试环境接口前缀
    test: 'http://zscrmdev.yejibao.vip/index.php/',

        // 打包生产环境接口前缀
    pro: window.location.origin+'/index.php/',
  },

  /**
   * 接口成功返回状态码
   */
  result_code: 1,

  /**
   * 接口请求超时时间
   */
  request_timeout: 60000,
  // request_timeout: 5400000,

  /**
   * 默认接口请求类型
   * 可选值：application/x-www-form-urlencoded multipart/form-data
   */
  default_headers: 'application/json'
}

export { config }
